export enum ContactInformationFields {
  EmailAddress = 'emailAddress',
  IsAuth = 'isAuth',
}
